import { Check } from './check.class';
import { merge } from 'lodash';

export class CheckAgitator extends Check {
  data: {
    timemeter?: number;
    thermalAjust?: number;
    isolation: {
      phase1?: number;
      phase2?: number;
      phase3?: number;
      conforme?: boolean;
    };
    measures: Array<{tension?: number, intensity?: number, power?: number}>;
    intensityMeasuresImpossible?: boolean;
    comments?: string;
  };

  constructor(obj?: any) {
    super(CheckAgitator.type);

    if(!obj) obj = {};

    this.data = merge({
        isolation: {
        },
        measures: [{}, {}, {}],
        comments: '',
      },
      obj.data
    );
  }

  public static type = 'agitator';
}



// WEBPACK FOOTER //
// ./src/app/models/check/check-agitator.class.ts